// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 修改聊天室解盘点赞状态 PUT /chat_stream_msg/like */
export async function chatStreamMsgLikeUsingPUT(
  body: API.UpdateChatStreamLikeReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/chat_stream_msg/like', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 解盘列表 GET /chat_stream_msg/list */
export async function chatStreamMsgListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.chatStreamMsgListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListWebChatStreamMessageResp>('/chat_stream_msg/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取播放凭证 GET /chat_stream_msg/vod/video/auth */
export async function chatStreamMsgVodVideoAuthUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.chatStreamMsgVodVideoAuthUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultGetVideoPlayAuthResponse>('/chat_stream_msg/vod/video/auth', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
